<script>
import { createEventDispatcher, afterUpdate, beforeUpdate } from 'svelte';
import { layers } from './layers.js';

const dispatch = createEventDispatcher();

let isPaused = true;
let displayLegends = true;
export let z;
export let currFrame;
export let frames;
let minZoom = 6;
let maxZoom = 19;
let visibleLayers = [];

function togglePause() {
    isPaused = !isPaused
    dispatch('togglepause', {isPaused: isPaused});
}

function handleNext() {
    isPaused = true
    dispatch('handlenext');
}

function handlePrevious() {
    isPaused = true
    dispatch('handleprevious');
}

function toggleLegends() {
    displayLegends = !displayLegends
}

function toggleVisibility(layer) {
    dispatch('togglevisibility', {layer: layer});
}

function zoomIn() {
    dispatch('zoom', {z: z+1});
}

function zoomOut() {
    dispatch('zoom', {z: z-1});
}

function activateLayers(visibleLayers) {
    for (var i=0; i<visibleLayers.length; i++) {
        toggleVisibility(visibleLayers[i]);
    }
}

function handleCheck(layer) {
    toggleVisibility(layer);
    deactivateLayersNotInSameTimeFrame(layers.filter(a => a.layer == layer)[0].interval);
}

function deactivateLayersNotInSameTimeFrame(interval) {
    deactivateLayers(layers.filter(a => a.interval != interval).map(x => x.layer));
}

function deactivateLayers(layerNames) {
    for (var i=0; i<visibleLayers.length; i++) {
        if (!layerNames.includes(visibleLayers[i])) 
            continue;
        toggleVisibility(visibleLayers[i]);
        visibleLayers = visibleLayers.filter(a => a !== visibleLayers[i]);
    }
}

function isMobile() {
    return (window.matchMedia('only screen and (max-device-width : 1024px)').matches)
}
</script>

<style>
label {
  display: block;
  margin-bottom: 3px;
}
.legends-container {
    order: 2;
    z-index: 2;
    position: relative;
    margin-left: auto;
}
.toggle-legends {
    position: absolute;
    z-index: 3;
    right: 10px;
    top: 10px;
    line-height: 1rem;
    font-size: 0.8rem;
}
.legends {
  background: white;
  padding: 10px;
  right: 20px;
  top: 20px;
  font-size: 0.9em;
  width: 410px;
  margin-bottom: 20px;
}
@media only screen and (max-device-width : 1024px) {
  .legends-container {
    width: 100%;
    order: -1;
    margin-bottom: 4px;
  }
  .legends {
    padding: 10px;
    right: 0px;
    top: 0px;
    width: auto;
    }
    .toggle-legends {
        position: relative;
        right: 0;
        top: 0;
        line-height: 1rem;
        margin-top: 20px;
    }
}

select {
    width: 100%;
}
</style>
<div class="legends-container">
    <button class="toggle-legends" on:click={toggleLegends}>x</button>
    <div class="legends" style="display: {displayLegends ? "block" : "none"}">
        {#if currFrame <= 0}
            <button disabled title="Previous">←</button>
        {:else}
            <button on:click={handlePrevious} title="Previous">←</button>
        {/if}
        
        <button on:click={togglePause} title="Play/Pause animation">{#if isPaused}Play{:else}Pause{/if}</button>

        {#if currFrame+1 >= frames}
            <button disabled title="Next">→</button>
        {:else}
            <button on:click={handleNext} title="Next">→</button>
        {/if}
        
        {#if z >= maxZoom}
            <button disabled>+</button>
        {:else}
            <button on:click={zoomIn} title="Zoom in">+</button>
        {/if}
        {#if z <= minZoom}
            <button disabled>-</button>
        {:else}
            <button on:click={zoomOut} title="Zoom out">-</button>
        {/if}
        {#if !isMobile()}
            {#each layers as l, i}
            <label>
                <input type=checkbox 
                    bind:group={visibleLayers} 
                    on:change={() => handleCheck(l.layer)}
                    value={l.layer}>
                {l.title} <sup><small><a target="_blank" href="https://geo.weather.gc.ca/geomet?version=1.3.0&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&layer={l.layer}&format=image/png&STYLE={l.style}">?</a></small></sup>
            </label>
            {/each}
        {:else}
            <select value={visibleLayers} on:change="{(e) => handleCheck(e.target.value)}">
                <option value=''>--</option>
                {#each layers as l}
                    <option value={l.layer}>
                        {l.title}
                    </option>
                {/each}
            </select>
        {/if}
        
    </div>
</div>

